// Canonical hosted-page URL — the hosted-page-render EF serves every
// client-facing document at https://crewbit.app/{slug}/{route}/{token}
// (§T.115 Phase F; PAYMENT_METHOD_DOMAINS=["crewbit.app"] registered at
// §T.197). Build every share / email / open link through this helper —
// §Money.DeadPaymentShareLinks retired the crewbit.ca/i/{token} and
// app.crewbit.ca/invoice|quote/{token} idioms (no route served them).
//
// Byte-identical copy kept in crewbit-mobile/utils, crewbit-admin/src/lib and
// supabase/functions/_shared (three runtimes, one shape).

export const HOSTED_PAGE_ORIGIN = 'https://crewbit.app';

/** pay = invoice (F-U2) · q = quote (F-U3) · co = change order (F-U4). */
export type HostedPageRoute = 'pay' | 'q' | 'co';

export function hostedPageUrl(slug: string, route: HostedPageRoute, token: string): string {
  return `${HOSTED_PAGE_ORIGIN}/${encodeURIComponent(slug)}/${route}/${encodeURIComponent(token)}`;
}
